import { useMutation } from '@tanstack/react-query';
import { PhoneVerificationService } from '../services/PhoneVerificationService';
import type { ISendMfaCodeRequest } from '../types/PhoneVerification';

export const useSendMfaCode = () =>
  useMutation<void, unknown, ISendMfaCodeRequest>({
    mutationFn: (payload) => PhoneVerificationService.sendMfaCode(payload),
  });
